import { Alert } from '@mui/material';
import React from 'react';

export function AlertRequiredFields({ sx }) {
  return <Alert sx={sx} severity="warning">Для сохранения необходимо заполнить все обязательные поля, указанные *</Alert>;
}
